// extracted by mini-css-extract-plugin
export default {"rowWrapper":"domestic-quote-percentages_rowWrapper__AQFwO"};